import AdminApiV1 from '@/api/adminApi/AdminApiV1'
import { useCartStore } from '@/stores/CartStore'

class CartService {
  private get store() {
    return useCartStore()
  }

  // --- Products ---

  async addProduct(productId: number, quantity: number): Promise<void> {
    const { data } = await AdminApiV1.post('cart_items', { product_id: productId, quantity })
    await this.store.handleCartToken(data.cart_token)
  }

  // productId is the catalog product ID — the API resolves the cart item by it
  async updateProductQuantity(productId: number, delta: number): Promise<void> {
    const { data } = await AdminApiV1.put(`cart_items/${productId}`, { quantity: delta })
    await this.store.handleCartToken(data.cart_token)
  }

  async deleteProduct(cartItemId: number): Promise<void> {
    const { data } = await AdminApiV1.delete(`cart_items/${cartItemId}`)
    await this.store.handleCartToken(data.cart_token)
  }

  // --- Mixes ---

  async addMix(mix: Record<string, unknown>, kind: string, quantity: number): Promise<void> {
    const { data } = await AdminApiV1.post('cart_mixes', { mix, kind, quantity })
    await this.store.handleCartToken(data.cart_token)
  }

  async updateMix(hash: string, mix: Record<string, unknown>, kind: string, quantity: number): Promise<void> {
    const { data } = await AdminApiV1.put(`mixes/${hash}`, { mix, kind, quantity })
    await this.store.handleCartToken(data.cart_token)
  }

  async duplicateAndAddMix(hash: string, quantity: number): Promise<void> {
    const { data } = await AdminApiV1.post('mixes/add-to-cart', { hash, quantity })
    await this.store.handleCartToken(data.cart_token)
  }

  async updateMixQuantity(mixId: number, delta: number): Promise<void> {
    const { data } = await AdminApiV1.put(`cart_mixes/${mixId}`, { quantity: delta })
    await this.store.handleCartToken(data.cart_token)
  }

  async deleteMix(mixId: number): Promise<void> {
    const { data } = await AdminApiV1.delete(`cart_mixes/${mixId}`)
    await this.store.handleCartToken(data.cart_token)
  }

  // --- Tube assignment ---

  async setProductTube(cartItemId: number, tubeUuid?: string): Promise<void> {
    const { data } = await AdminApiV1.put('cart_items/change-tube', { id: cartItemId, tube_uuid: tubeUuid })
    await this.store.handleCartToken(data.cart_token)
  }

  async setMixTube(mixId: number, tubeUuid: string): Promise<void> {
    const { data } = await AdminApiV1.put('cart_mixes/change-tube', { id: mixId, tube_uuid: tubeUuid })
    await this.store.handleCartToken(data.cart_token)
  }

  async renameMix(mixId: number, name: string): Promise<void> {
    const { data } = await AdminApiV1.put('cart_mixes/rename-mix', { id: mixId, name })
    await this.store.handleCartToken(data.cart_token)
  }

  // --- Discounts ---

  async setDiscountCode(code: string): Promise<void> {
    const { data } = await AdminApiV1.post('cart/set-discount-code', { code })
    await this.store.handleCartToken(data.cart_token)
  }

  async setCreditDiscount(useCredits: boolean): Promise<void> {
    const { data } = await AdminApiV1.post('cart/set-credit-discount', { use_credits: useCredits })
    await this.store.handleCartToken(data.cart_token)
  }
}

export const cartService = new CartService()
